<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="top">
    <div class="t_name">
      <p class="cn">目录</p>
      <p class="en">contents</p>
    </div>
    <p class="detail">
      本报告所依赖数据都来自于线上或线下真实发生的行为所产生的数据，本次用于生成报告的数据为
      {{ taskSum }} 份。
    </p>
  </div>

  <div class="item" v-for="({ title, child }, index) in catalogue" :key="index">
    <div class="title">
      <div class="index">{{ `${index + 1}`.padStart(2, '0') }}</div>
      <div class="name">{{ title }}</div>
    </div>
    <div class="child" v-if="Array.isArray(child)">
      <div
        class="child-item"
        v-for="({ title, num }, childIndex) in child"
        :key="childIndex"
      >
        <p class="child-item-name">{{ title }}</p>
        <div class="hr"></div>
        <p class="child-item-number">
          {{ `${num}`.padStart(2, '0') }}
        </p>
      </div>
    </div>
  </div>
  <div class="_bg"></div>
</template>

<script setup lang="tsx">
import { watch } from 'vue';
type CataLogueType = Array<{
  title: string;
  num: number;
  child: CataLogueType;
}>;
const props = withDefaults(
  defineProps<{ taskSum?: number; catalogue: CataLogueType }>(),
  {
    taskSum: 1
  }
);
const emits = defineEmits(['catalogueFinish']);
watch(
  () => props.catalogue,
  () => {
    emits('catalogueFinish');
  }
);
</script>
<style lang="scss" scoped>
@import './index.scss';
$left: var(--custom-page-left);
._bg {
  content: '';
  width: 22px;
  height: calc(100% - var(--custom-page-top));
  position: absolute;
  left: $left;
  top: var(--custom-page-top);
  background-color: var(--theme-color-1);
  z-index: 1;
}
.top {
  position: absolute;
  top: 0;
  left: $left;
  padding-top: 30px;
}
.t_name {
  .cn {
    font-size: 77px;
    font-weight: 500;
    line-height: 1;
    color: var(--theme-color-1);
  }
  .en {
    font-size: 36px;
    font-weight: 500;
    line-height: 1.4;
    color: #0f0f0f;
    text-transform: capitalize;
  }
}
.detail {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.6;
  color: #3e3e3e;
  padding-top: 12px;
  padding-right: 24px;
  @include line_clamp(2);
}

.item {
  .title {
    display: flex;
    align-items: center;
    height: 100px;
    box-sizing: border-box;
    border-left: 14px solid var(--theme-color-1);
    padding-left: 20px;
    margin-left: 70px;
    position: relative;
    background: linear-gradient(94deg, #f4f4f4 0%, #ffffff 100%);
    .index {
      color: var(--theme-color-1);
      font-size: 50px;
      font-weight: 500;
      flex-shrink: 0;
    }
    .name {
      font-size: 30px;
      font-weight: 500;
      line-height: 69px;
      padding: 0 18px;
      color: #222222;
      @include line_clamp(1);
    }
  }
  .child {
    padding-left: 190px;
    padding-top: 20px;
    .child-item {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      color: #222222;
      padding: 18px 0;
    }
    .hr {
      flex-grow: 1;
      height: 1pt;
      background-color: #142666;
      margin-left: 18px;
      margin-right: 6px;
    }
    .child-item-name {
      max-width: 60%;
      @include line_clamp(1);
    }
    .child-item-number {
    }
  }
}
</style>
